import { base_url } from "./baseUrl";

function apiOrigin() {
  try {
    return new URL(base_url).origin;
  } catch {
    return "";
  }
}

/**
 * - API often stores `http://localhost:3001/images/...` while the admin dev server
 *   runs on that port too; CRA does not serve `/images/*` (uploads live on the API).
 *   Paths under `/images/` are rewritten to the API origin from `base_url`.
 * - If you open the admin via a LAN hostname, loopback URLs in stored data are fixed.
 * - Optional: REACT_APP_MEDIA_URL (no trailing slash) overrides the asset origin.
 */
export function resolveMediaUrl(stored) {
  if (!stored || typeof stored !== "string") return "";

  const envRoot = process.env.REACT_APP_MEDIA_URL;
  if (envRoot) {
    try {
      const { pathname, search } = new URL(stored);
      return `${envRoot.replace(/\/$/, "")}${pathname}${search}`;
    } catch {
      return stored;
    }
  }

  const origin = apiOrigin();

  try {
    const u = new URL(stored);
    const path = u.pathname || "";
    if (origin && path.startsWith("/images/")) {
      return `${origin}${path}${u.search}`;
    }
    const pageHost = window.location.hostname;
    const loopback = u.hostname === "localhost" || u.hostname === "127.0.0.1";
    if (
      loopback &&
      pageHost &&
      pageHost !== "localhost" &&
      pageHost !== "127.0.0.1"
    ) {
      u.hostname = pageHost;
      return u.toString();
    }
  } catch {
    if (origin && stored.startsWith("/images/")) {
      return `${origin}${stored}`;
    }
    return stored;
  }

  return stored;
}
